import { z } from "zod"
import type { PimTargetRecoveryProof } from "./pim-event-recovery"

export const productVisualFillSettlementSelectionSchema = z
  .object({
    jobId: z.string().uuid(),
    simpleSku: z.string().min(1).max(256),
  })
  .strict()
export const productVisualFillSettlementExecuteSchema = productVisualFillSettlementSelectionSchema
  .extend({
    evidenceHash: z.string().regex(/^[a-f0-9]{64}$/),
  })
  .strict()
export const productVisualFillSettlementIdSchema = z.string().uuid()
export type ProductVisualFillSettlementSelection = z.infer<
  typeof productVisualFillSettlementSelectionSchema
>
export type ProductVisualFillSettlementProof = Omit<PimTargetRecoveryProof, "publishedAt">
export type ProductVisualFillSettlementIdentity = {
  workId: string
  store: string
  productId: number
  simpleSku: string
  kind: "nutrition"
  frontierHash: string
  frontierJobIds: string[]
}
export type ProductVisualFillSettlementPreview = {
  selection: ProductVisualFillSettlementSelection
  identity: ProductVisualFillSettlementIdentity | null
  evidenceHash: string
  blockers: string[]
  proof: ProductVisualFillSettlementProof | null
  settlementId: string | null
}
